export class ViewingUpdate {
  constructor(
      public id: number,
      public preferredTime: string,
      public preferredDate: string
    ) {  }
}



// WEBPACK FOOTER //
// D:/FLINK/FlinkViewingPageDec2020/NewLandingPage/src/app/viewingForm/viewing-update.ts